import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/", label: "首页", icon: "ri-camera-line" },
  { to: "/records", label: "记录", icon: "ri-list-check-2" },
  { to: "/analysis", label: "分析", icon: "ri-donut-chart-line" },
  { to: "/community", label: "社区", icon: "ri-group-line" },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-white/95 backdrop-blur border-t border-warm-200 z-40">
      <ul className="flex justify-around items-center h-16 px-2">
        {tabs.map((t) => (
          <li key={t.to} className="flex-1">
            <NavLink
              to={t.to}
              end={t.to === "/"}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-colors ${
                  isActive ? "text-mint-500" : "text-gray-400"
                }`
              }
            >
              <span className="w-6 h-6 flex items-center justify-center">
                <i className={`${t.icon} text-xl`}></i>
              </span>
              <span className="text-[11px] whitespace-nowrap">{t.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}